export default {
  props: {
    button: 'button',
    content: 'content',
    contentLabel: 'contentLabel'
  }
};
